import React, { useEffect } from "react";
import "./DeviceList.css";
import MainLayout from "components/layout/main-layout/MainLayout.js";
import { titles } from "constants/titles";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { RightFill } from "assets/SVGs/SVGs";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAneltoTimeline,
  getClairvoyantTimeline,
  getDeviceList,
  getEviewTimeLine,
  getFreeusTimeline,
  setSelectedDeviceDetails,
} from "redux/Devices/actions";
import {
  GET_DEVICE_DETAILS,
  RESET_DEVICE_SYNC_LOG,
} from "redux/Devices/actionTypes";
import { setSelectedMedicalUser } from "redux/MedicalAlertUsers/actions";

const DeviceList = () => {
  const userData = useSelector((store) => store?.auth?.userData);
  const { deviceList, loading } = useSelector((store) => store?.devices);
  const { medicalUserTimezone } = useSelector((store) => store?.common);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    getAllDeviceList();
  }, []);

  const getAllDeviceList = () => {
    const param = {
      dispatch,
      history,
      userType: userData?.isGuestUser ? "guestuser" : "accountowner",
    };
    getDeviceList(param);
    getAneltoTimeline(param);
    getFreeusTimeline(param);
    getClairvoyantTimeline(param);
    getEviewTimeLine(param);
  };

  const onDeviceProfileClick = async (item) => {
    setSelectedDeviceDetails(dispatch, item);
    dispatch({
      type: GET_DEVICE_DETAILS,
      payload: null,
    });
    dispatch({
      type: RESET_DEVICE_SYNC_LOG,
      payload: [],
    });
    const timeZoneData = await medicalUserTimezone?.find(
      (data) => data?.medicalAlertUserId === item?.medical_alert_user_id
    );
    setSelectedMedicalUser(dispatch, {
      ...timeZoneData,
      medical_alert_user_id: timeZoneData?.medicalAlertUserId,
    });
    setTimeout(() => {
      history.push(ROUTES_CONSTANTS?.deviceProfile);
    }, 300);
  };

  return (
    <MainLayout
      text={titles?.all_subscriber_devices}
      isBackHide={true}
      isNavbar={true}
      white={true}
      primary={true}
    >
      <div className="dl_container">
        <div className="dl_section_title">
          <h2 className="dl_title">{titles?.get_access_each_subscriber}</h2>
        </div>
        <div className="dl_device_list">
          {deviceList?.map((item, index) => (
            <div
              key={`device-${index}`}
              className="dl_device_card"
              onClick={() => onDeviceProfileClick(item)}
            >
              <div className="dl_device_image_container">
                <img
                  src={item?.image_url}
                  alt={item?.device_name}
                  className="dl_device_image"
                />
              </div>
              <div className="dl_device_info">
                <h3 className="dl_device_name">{item?.device_name}</h3>
                <p className="dl_device_subscriber">
                  {item?.subTitle || `${item?.firstname} ${item?.lastname}`}
                </p>
              </div>
              <div className="dl_device_action">
                <button
                  className="dl_see_device_btn"
                  onClick={() => onDeviceProfileClick(item)}
                >
                  <RightFill width="32" height="32" />
                </button>
              </div>
            </div>
          ))}
        </div>
        {!loading && deviceList?.length <= 0 && (
          <div className="dl_empty_state">
            <p className="dl_empty_text">{titles?.no_device_available}</p>
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default DeviceList;
